import React, { useState, useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import { HotlineCard } from '../components/HotlineCard';
import Theme from "../components/theme";
import { collection, getDocs, query } from 'firebase/firestore';
import { firestore } from '../firebase.js';

function HotlinePage() {
  const [hotlines, setHotlines] = useState([]);

  const getHotlines = async () => {
    const q = query(collection(firestore, "hotlines"));
    let querySnapshot = await getDocs(q);
    querySnapshot = querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
    setHotlines(querySnapshot);
  }

  useEffect(() => {
    getHotlines();
  }, []);

  return (
    <Theme>
      <Box className="px-4 sm:px-8 py-6 max-w-screen-lg mx-auto">
        <Typography color="primary" variant="h3" align="center" sx={{ mb: 4}}>
          Hotlines
        </Typography>

        <div className="flex flex-col gap-6 items-center">
          {hotlines.length !== 0 ? (
            hotlines.map((hotline) => (
              <HotlineCard key={hotline.id} hotlineInfo={hotline} />
            ))
          ) : (
            <Typography variant="h5" sx={{ mt: 4 }} align="center">
              No Available Hotlines
            </Typography>
          )}
        </div>
      </Box>
    </Theme>
  );
}

export default HotlinePage;
